import React, {useEffect, useState} from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import {api} from "../../api/api";

export default function GrinchCommentDialog(props) {
    const [comment, setComment] = useState("");
    const [activateAction, setActivateAction] = useState(true);
    const [receiver, setReceiver] = useState(null);

    useEffect(() => {
        if (props.open) {
            setComment(props.receiver.grinchComment || "");
            setActivateAction(props.activateAction);
            setReceiver(props.receiver);
        }
    }, [props.open, props.activateAction,props.receiver]);

    const handleOnClose = () => {
        props.handleClose();
    };

    const handleOnApprove = () => {
        (async () => {
            api.secretSanta.setGrinchStatus(receiver.id, activateAction, comment)
                .then(grinch => {
                    props.onSuccess(grinch);
                    props.handleClose();
                })
                .catch((error) => {
                    props.onFetchFailed(error);
                });
        })();
    };

    let title = "";
    let buttonText = "";

    if (activateAction) {
        title = receiver?.isGrinch ? "Edit Grinch Comment" : "Make Grinch";
        buttonText = receiver?.isGrinch ? "Save" : "Make Grinch";
    } else {
        title = "Unmake Grinch";
        buttonText = "Unmake Grinch";
    }

    return (
        <Dialog
            open={props.open}
            onClose={handleOnClose}
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Comment"
                    type="text"
                    fullWidth
                    variant="standard"
                    multiline
                    rows={4}
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleOnClose} color="primary">
                    Cancel
                </Button>
                <Button
                    onClick={handleOnApprove}
                    variant="contained"
                    color="secondary"
                >
                    {buttonText}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
